import React from 'react';
import { FieldError, ProfileContainer } from '~/modules/components/global/preferences/preferences.css';
import SelectMenu from '~/modules/components/global/select';
import PropTypes from 'prop-types';
import TwoFactorSection from '~/modules/components/global/preferences/two-factor-section';
import PasskeysSection from '~/modules/components/global/preferences/passkeys-section';

const ProfilePreferences = ({
	preferences, handlePreferencesChange, session, setUser, user, territoriesOptions
}) => {
	const name = user?.name ?? '';
	const isNameMissing = name.trim() === '';

	return (
		<ProfileContainer data-testid="preferences-profile">
			{/* Who you are, first: the three things somebody opens this tab to read or change,
			    above the credentials that follow. */}
			<fieldset>
				<legend className="h6">
					<label htmlFor="profileName">Name</label>
					<input
						type="text"
						name="name"
						id="profileName"
						data-testid="preferences-profile-name-input"
						value={name}
						onChange={(e) => setUser({ ...user, name: e.target.value })}
					/>
					{ isNameMissing && (
						<FieldError data-testid="preferences-profile-name-error">
							A name is required
						</FieldError>
					) }
				</legend>

				{/* Not editable here. The address is the account -- every credential path looks
				    an account up by it, and changing it is an identity change rather than a
				    preference. */}
				<legend className="h6">
					<label htmlFor="profileEmail">Email Address</label>
					<input
						type="text"
						name="emailNormal"
						id="profileEmail"
						data-testid="preferences-profile-email-input"
						value={session.emailNormal}
						disabled
					/>
				</legend>

				<legend className="h6">
					<label htmlFor="profileTerritory">Territory</label>
					<SelectMenu
						inputId="profileTerritory"
						className="territory-preference"
						options={territoriesOptions}
						value={territoriesOptions.find((o) => o.value === user?.territory?._id)}
						onChange={(territory) => setUser({
							...user,
							territory: { name: territory.name, _id: territory.value }
						}) }
						maxMenuHeight={200}
					/>
				</legend>
			</fieldset>

			{/* Passkeys first: one replaces the password outright, where the section below adds a
			    step to it. Ordered by what a person should reach for. */}
			<PasskeysSection/>
			<TwoFactorSection
				preferences={preferences}
				handlePreferencesChange={handlePreferencesChange}
				user={user}
			/>
		</ProfileContainer>
	);
};

ProfilePreferences.propTypes = {
	session: PropTypes.object,
	user: PropTypes.object,
	preferences: PropTypes.object,
	territoriesOptions: PropTypes.array,
	handlePreferencesChange: PropTypes.func,
	setUser: PropTypes.func
};
export default ProfilePreferences;
